import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `cambioEstadoVerraco/addNuevoEstado`, method: 'POST', body: values, token: token})
}
